const QuienesSomosData = [
    {id: 1,
    nombre: 'Clato',
    img: '/img/QuienesSomos/Clato.webp',
    texto: 'Soluciones creativas, posicionamiento de mercado y jugos de fruta 🍉'
    },
    {id: 2,
    nombre: 'Ludmila',
    img: '/img/QuienesSomos/Ludmila.webp',
    texto: 'Arte visual y project manager. Perritos lover 🐶'
    },
    {id: 3,
    nombre: 'Octavio',
    img: '/img/QuienesSomos/Octavio.webp',
    texto: 'Desarrollo web, inteligencia comercial y Boca Juniors ✋🏼😄🤚🏼'
    },
  /*  {id: 4,
    nombre: 'Lo',
    img: '/img/QuienesSomos/Lo.webp',
    texto: 'Comunicación, diseño y fotografía en proceso 📷'
    },  */
    {id: 5,
    nombre: 'Francina',
    img: '/img/QuienesSomos/Francina.webp',
    texto: 'Creación de contenido, desarrollo web, multitarea. Videojuegos y rugby 🕹️🏉'
    },

   {id: 6,
   nombre: 'Bere',
   img: '/img/QuienesSomos/Bere.webp',
   texto: 'Realización audiovisual. Que la fuerza te acompañe ⭐'
                                                                },         
]


export default QuienesSomosData;